/* eslint-disable arrow-body-style */
/* eslint-disable no-restricted-syntax */
import moment from 'moment';

// convert object to array, preserve the keys
const toArray = obj => Object.keys(obj).map(key => ({ key, value: obj[key] }));

/**
 * is app running as PWA
 */
const isInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches
  || window.navigator.standalone
  || document.referrer.includes('android-app://');

/** public image source */
const baseUrl =  process.env.NODE_ENV === 'production' ? process.env.PUBLIC_URL : 'images';

/**
 * Calculate age
 * @param {*} dateOfBirth
 */
const calculateAge = (dateOfBirth) => {
  const today = new Date();
  const birthDate = new Date(
    dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'),
  );
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

/**
 * Format date e.g. from 12122020 to 12/12/2020
 * @param {*} date
 */
const formatDate = (date) => {
  if (date.length <= 4 && date.length > 2) {
    return date.replace(/(\d{2})(\d{1,2})/, '$1/$2');
  }
  if (date.length <= 8) {
    return date.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
  }
  return date;
};

// const appendScript = (scriptToAppend) => {
//   const script = document.createElement('script');
//   script.src = scriptToAppend;
//   script.async = true;
//   document.body.appendChild(script);
// };

// const removeScript = (scriptToremove) => {
//   const allsuspects = document.getElementsByTagName('script');
//   for (let i = allsuspects.length; i >= 0; i--) {
//     if (allsuspects[i] && allsuspects[i].getAttribute('src') !== null
// && allsuspects[i].getAttribute('src').indexOf(`${scriptToremove}`) !== -1) {
//       allsuspects[i].parentNode.removeChild(allsuspects[i]);
//     }
//   }
// };

const checkPropertiesIsWithValue = (obj) => {
  // for (const key in obj) {
  //   if (obj[key] !== null && obj[key] !== '') { return true; }
  // }
  // return false;
  const result = !Object.values(obj).every(o => o === null || o === '');
  return result;
};

/** Convert unix date/time into Standard date format */
const convertUnixDateToStandard = date => moment(date).format('ll');

/** is Date/time less than the date/time now? */
const isPastDateTime = (timestamp) => {
  const normalDate = moment(timestamp);
  const dateNow = new Date();
  return moment(dateNow).isSameOrAfter(normalDate);
};

const lastLoginFromToken = (token) => {
  const encodedString = token.split('.')[1];
  const decodedString = atob(encodedString);
  return moment(decodedString.iat);
};

const scrollToError = () => {
  // when the function called the error might
  setTimeout(() => {
    const openedTag = document.getElementsByClassName('nw-accordion--open');
    if (!openedTag || !openedTag[0]) {
      return;
    }
    // get all the error element of current opening tag
    const errors = openedTag[0].getElementsByClassName('notification--error');
    if (errors && errors.length) {
      const error = errors[0];
      // for different type of element we need to scroll to different position
      if (error && error.parentElement) {
        const parrent = error.parentElement;
        const className = parrent.getAttribute('class');
        if (className === 'options' && parrent.parentElement) {
          parrent.parentElement.scrollIntoView({ behavior: 'smooth' });
          // eslint-disable-next-line no-empty
        } else if (className === 'padded-container' && error.previousSibling) {
          error.previousSibling.scrollIntoView({ behavior: 'smooth' });
        } else {
          parrent.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }, 300);
};

/** This is to add investment experience data on the payload */
const investmentExp = (data) => {
  const convertedData = {
    ...data,
    investmentExp: [
      {
        assetClass: 'NW-MAR-ASC-BOND',
        strategy: data.clientProfileForm.ieBondsStrategy,
        years: data.clientProfileForm.ieBondsYrs,
      },
      {
        assetClass: 'NW-MAR-ASC-EQU',
        strategy: data.clientProfileForm.ieEquitiesStrategy,
        years: data.clientProfileForm.ieEquitiesYrs,
      },
      {
        assetClass: 'NW-MAR-ASC-REAL',
        strategy: data.clientProfileForm.ieRealEstateStrategy,
        years: data.clientProfileForm.ieRealEstateYrs,
      },
      {
        assetClass: 'NW-MAR-ASC-ALT',
        strategy: data.clientProfileForm.ieOtherAlternativeInvestmentsStrategy,
        years: data.clientProfileForm.ieOtherAlternativeInvestmentsYrs,
      },
      {
        assetClass: 'NW-MAR-ASC-EAH',
        strategy: data.clientProfileForm.iePrivateEquityHedgeFundsStrategy,
        years: data.clientProfileForm.iePrivateEquityHedgeFundsYrs,
      },
    ],
  };
  return convertedData;
};

/** Format number into 2 decimal points */
const formatNumberToDecimal = (value) => {
  try {
    if (Number.isNaN(parseFloat(value))) return '';

    return new Intl.NumberFormat('en', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch (err) {
    return `error formatting ${err.message}`;
  }
};

/** Just add "%" after the string */
const formatAsPercentage = (value) => {
  if (!value) return '-';
  return `${value} %`;
};

const getStringAfterSpecialChar = (string, char) => {
  const newStr = string.split(char).pop();
  return newStr;
};

/** translate answer or default value */
const translateAnswer = (str, intl) => {
  return str ? intl.formatMessage({ id: str.toLowerCase() }) : str;
};

const isCurrentDate = (variableDateUnixTime) => {
  // Get the current date components
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
  const currentDay = currentDate.getDate();

  // Convert the variable date to a JavaScript Date object
  const variableDate = new Date(variableDateUnixTime * 1000);

  // Extract the components of the variable date
  const variableYear = variableDate.getFullYear();
  const variableMonth = variableDate.getMonth() + 1; // Months are zero-based
  const variableDay = variableDate.getDate();

  // Compare year, month, and day
  return (
    variableYear === currentYear
    && variableMonth === currentMonth
    && variableDay === currentDay
  );
};

const isCardMonthYearValid = (numbers) => {
  if (!numbers || numbers === "") {
    return false;
  }

  if (numbers.length < 4) {
    return false;
  }

  const month = parseInt(numbers.slice(0, 2), 10);
  const year = parseInt(numbers.slice(2, 4), 10);

  const now = new Date();
  const currentYear = now.getFullYear() % 100;
  const currentMonth = now.getMonth() + 1;

  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return false;
  }

  return true;
};

const isLastFourDigitsValid = (inputValue) => {
  if (!inputValue || inputValue === '') {
    return false;
  }

  if (inputValue.length !== 4) {
    return false;
  }

  return true;
};

const utils = {
  toArray,
  isInStandaloneMode,
  baseUrl,
  calculateAge,

  formatDate,
  isPastDateTime,

  checkPropertiesIsWithValue,
  // appendScript,
  // removeScript,

  lastLoginFromToken,
  convertUnixDateToStandard,
  scrollToError,

  investmentExp,

  formatNumberToDecimal,
  formatAsPercentage,

  getStringAfterSpecialChar,
  translateAnswer,

  isCurrentDate,

  isCardMonthYearValid,
  isLastFourDigitsValid,
};

export default utils;
